module.exports = __webpack_public_path__ + "static/icon-Facebook-513c17445a5cef5221cd16751cc994ef.png";